<div class="c-vert-stepper" id="stepper">
    <ul class="c-vert-stepper__list">
        @for (step of steps; track step) {
            <li class="c-vert-stepper__item is-active">
                <medpace-vertical-stepper-link
                    (click)="stuff(step)"
                    [stepName]="step.name"
                    [stepIdentifier]="step.identifier"
                    [isActive]="step.isActive"
                    [offsetElement]="navbar"
                ></medpace-vertical-stepper-link>
            </li>
        }
    </ul>
    <div class="c-vert-stepper__line"></div>
</div>
